/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import {  Skeleton, Progress, Row, Col, Form, Select } from "antd";
import {
  mergeRequests,
} from "../utils/transform";
import { MajorTable } from "./Table";
import { SearchBar } from "./SearchBar";
import { AlternateApproverSelect, Box } from "../../../../../components";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../components/styled-antd";
import { approveRequest } from "../utils/handle-request";
import * as _ from "lodash";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import { PATH } from "../constant";
import { CreateNotification } from "../../../../../components/notifier";
import { useSelector } from "../../../../../store/store";
import { getPage } from "../utils/get-page";
import { HOSummaryEmployeeRequestService as serivce } from "../../../../../services/human-organization/summary-register-request.service";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";
import { MAIL_TEMPLATE } from "../constant";
import { getEmployeeDetail } from "../utils/get-employee-detail";
import { getEnv } from "../../../../../AppConfigs";
import { getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { MailService } from "../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../constants/mailTemplateConstants";
import { filterEmployee, getEmployeeBizTitleByBranch } from "../../summary-employee-request/utils/get-employee-detail";

export function MajorTableList() {
  const history = useHistory();
  const routeMatch = useRouteMatch();
  const location = useLocation<any>();

  const { getITLeadITHeadAssignee } = useSoftwares();

  const originalDataSource = location.state?.dataSource;
  const eLocation = location.state?.eLocation || "";

  const [dataSource, setDataSource] = useState<any[]>(originalDataSource || []);

  const [progress, setProgress] = useState<number>(0);
  const [isDisplayProgress, setIsDisplayProgress] = useState<boolean>(false);
  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );

  const approveRequests = (value: any) => {
    setIsDisplayProgress(true);

    const newDataSource = mergeRequests(dataSource);

    let func = async (number: number) => {
      setProgress((number * 100) / (newDataSource.length - 1));

      const result = await approveRequest(
        newDataSource[number],
        currentUserName,
        getITLeadITHeadAssignee(SystemCode.SER),
        pickedUser && pickedUser != "" ? pickedUser : value.eApprovedBy,
        pickedUser2 && pickedUser2 != "" ? pickedUser2 : value.eApprovedBy2, 
        eLocation
      );

      if (number >= newDataSource.length - 1) {
        CreateNotification({
          title: "Thành công",
          body: `Xác nhận yêu cầu thành công`,
          icon: "/icons/success.png",
        });

        sendMail(
          `${result?.fields?.eApprovedBy}|${
            getEmployeeDetail(
              result?.fields?.eApprovedBy || "",
              employees,
              softwares
            )?.[0]?.Title
          }`,
          result,
          MAIL_TEMPLATE.APPROVE
        );

        history.push(PATH.HOME);
      }
    };

    // Defining for loop
    for (let i = 0; i < newDataSource.length; i++) {
      _.delay(func, 2000 * i, i);
    }
  };

  const siteUrl = getEnv("REACT_APP_SUMMARY_REGISTER_REQUEST");

  const sendMail = async (
    approver: any,
    itRepairToolRequest: any,
    type: string
  ) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;

    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === type);
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(
        mailRegexs.two + ";",
        itRepairToolRequest.createdBy.user.displayName
      )
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(
          itRepairToolRequest.createdDateTime
        )} - ${getHHmmFormat(itRepairToolRequest.createdDateTime)}`
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(
      subject,
      content,
      "html",
      tomail
    );
    await MailService.sendMail(message);
  };

  const [pickedUser, setPickedUser] = useState("");
  const [pickedUser2, setPickedUser2] = useState("");

  return (
    <Box title="Danh sách BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC">
      {getPage(routeMatch) === PATH.HOME && (
        <SearchBar dataSource={dataSource} setDataSource={setDataSource} />
      )}

      {dataSource.map((_, index) => (
        <div className="mt-3">
          <MajorTable
            dataSource={dataSource}
            setDataSource={setDataSource}
            index={index}
          />
        </div>
      ))}

      <Form onFinish={approveRequests} size="large">
        {dataSource.length != 0 && getPage(routeMatch) === PATH.CREATE && (
          <>
            <Row gutter={[32, 0]} className="mt-3">
              <Col span={12}>
                <StyledTitle level={5}>
                  Chọn {getEmployeeBizTitleByBranch(eLocation,"TP")}
                  {pickedUser === "" && (
                    <span className="text-danger">(*)</span>
                  )}
                </StyledTitle>
                <Form.Item
                  name="eApprovedBy"
                  rules={[
                    {
                      required: pickedUser === "",
                      message: "Chọn "+ getEmployeeBizTitleByBranch(eLocation,"TP"),
                    },
                  ]}
                >
                  <Select
                    options={filterEmployee([], eLocation, "TP")}
                    placeholder={getEmployeeBizTitleByBranch(eLocation,"TP")}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <StyledTitle level={5}>
                  Người duyệt thay thế cho {getEmployeeBizTitleByBranch(eLocation,"TP")}
                </StyledTitle>
                <AlternateApproverSelect
                  placeholder= "Người duyệt thay thế"
                  onChange={(value) => {
                    if (value) {
                      setPickedUser(value);
                    }
                  }}
                />
              </Col>
            </Row>

            <Row gutter={[32, 0]} className="mt-3">
              <Col span={12}>
                <StyledTitle level={5}>
                  Chọn
                  {eLocation == "TSN"
                    ? " Tổng Giám đốc"
                    : " Giám đốc chi nhánh"}
                  {pickedUser2 === "" && (
                    <span className="text-danger">(*)</span>
                  )}
                </StyledTitle>
                <Form.Item
                  name="eApprovedBy2"
                  rules={[
                    {
                      required: pickedUser2 === "",
                      message: `Chọn ${
                        eLocation == "TSN"
                          ? " Tổng Giám đốc"
                          : " Giám đốc chi nhánh"
                      }`,
                    },
                  ]}
                >
                  <Select
                    options={filterEmployee([], eLocation, "GD")}
                    placeholder={
                      eLocation == "TSN"
                        ? " Tổng Giám đốc"
                        : " Giám đốc chi nhánh"
                    }
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <StyledTitle level={5}>
                  Người duyệt thay thế cho{" "}
                  {eLocation == "TSN"
                    ? " Tổng Giám đốc"
                    : " Giám đốc chi nhánh"}
                </StyledTitle>
                <AlternateApproverSelect
                  placeholder= "Người duyệt thay thế"
                  onChange={(value) => {
                    if (value) {
                      setPickedUser2(value);
                    }
                  }}
                />
              </Col>
            </Row>

            {getPage(routeMatch) === PATH.CREATE && (
              <div className="d-flex justify-content-center mt-3">
                {!isDisplayProgress && (
                  <StyledButton bgColor="orange" htmlType="submit">
                    Xác nhận
                  </StyledButton>
                )}
                {isDisplayProgress && (
                  <Progress percent={Math.round(progress)} />
                )}
              </div>
            )}

            {/* <div className="d-flex justify-content-center mt-3">
            <Pagination defaultCurrent={0} total={1000} />
          </div> */}
          </>
        )}
      </Form>

      {dataSource.length == 0 && (
        <div className="d-flex justify-content-center text-secondary my-3">
          Không có dữ liệu
        </div>
      )}
    </Box>
  );
}

export function EditTableList() {
  const history = useHistory();
  const routeMatch = useRouteMatch();
  const location = useLocation<any>();

  const originalDataSource = location.state?.dataSource;

  const [dataSource, setDataSource] = useState<any[]>(originalDataSource || []);

  const progress = 0;
  const isDisplayProgress = false;
  const { id } = useRouteMatch().params as any;

  const [isLoading, setIsLoading] = useState(false);

  const initData = async () => {
    setIsLoading(true);
    const data = await serivce.getDetailsSummaryEmployeeRequest(id);
    setDataSource([
      { eMajor: data.fields.eMajor, data: JSON.parse(data.fields.eContent) },
    ]);
    setIsLoading(false);
  };

  useEffect(() => {
    initData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Skeleton />;
  }

  const approveRequests = async () => {
    if (dataSource[0]?.data?.length == 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Vui lòng nhập thông tin học viên`,
        icon: "/icons/error.png",
      });

      return;
    }

    try {
      await serivce.updateSummaryEmployeeRequest(id, {
        eContent: JSON.stringify(dataSource[0].data),
      });

      CreateNotification({
        title: "Thành công",
        body: `Cập nhật yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Cập nhật yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }
  };

  return (
    <Box title="Danh sách BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC">
      {getPage(routeMatch) === PATH.HOME && (
        <SearchBar dataSource={dataSource} setDataSource={setDataSource} />
      )}

      {dataSource.map((_, index) => (
        <div className="mt-3">
          <MajorTable
            dataSource={dataSource}
            setDataSource={setDataSource}
            index={index}
          />
        </div>
      ))}

      {dataSource.length != 0 && (
        <>
          {getPage(routeMatch) === PATH.CREATE && (
            <div className="d-flex justify-content-center mt-3">
              {!isDisplayProgress && (
                <StyledButton bgColor="orange" onClick={approveRequests}>
                  Xác nhận
                </StyledButton>
              )}
              {isDisplayProgress && <Progress percent={Math.round(progress)} />}
            </div>
          )}
        </>
      )}

      {dataSource.length == 0 && (
        <div className="d-flex justify-content-center text-secondary my-3">
          Không có dữ liệu
        </div>
      )}
    </Box>
  );
}

/**
dataSource: example 
*/
